import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { GameStateResponse } from '@/lib/api';

interface GameStateCardProps {
  state: GameStateResponse;
  onClick?: () => void;
}

function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

function getPreview(state: GameStateResponse): string {
  if (state.dataType === 'binary') {
    return `[Binary data, ${formatBytes(state.dataSizeBytes)}]`;
  }
  if (!state.data) return '[Empty]';
  if (state.data.length > 120) {
    return state.data.substring(0, 120) + '...';
  }
  return state.data;
}

export function GameStateCard({ state, onClick }: GameStateCardProps) {
  return (
    <Card
      className={onClick ? 'cursor-pointer hover:border-primary/50 transition-colors' : ''}
      onClick={onClick}
    >
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-mono">{state.keyword}</CardTitle>
          <div className="flex items-center gap-2">
            <Badge variant="outline" className="text-xs">
              v{state.version}
            </Badge>
            <Badge variant="secondary" className="text-xs">
              {state.dataType}
            </Badge>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-muted-foreground font-mono truncate">{getPreview(state)}</p>
        <p className="text-xs text-muted-foreground mt-1">
          {formatBytes(state.dataSizeBytes)} &middot; Updated{' '}
          {new Date(state.updatedAt).toLocaleDateString()}
        </p>
      </CardContent>
    </Card>
  );
}
